import React from 'react'
import { Navigate } from 'react-router-dom'
import { useUser } from '@/features/user/hooks'
import { useFromPath } from '@/hooks'
import { getPrivateInitialRoute } from '@/routes/helpers'
import { GUARD } from '../../guards'

interface IProps {
  children: React.ReactNode
  roles?: Array<string>
  guards?: Array<GUARD>

  [x: string]: any
}

export const RouteGuard: React.FC<IProps> = ({ children, roles, guards = [], ...props }) => {
  const from = useFromPath()

  const { user, isAdmin } = useUser()

  const withGuard = (type: GUARD) => {
    return guards.some((guard) => guard === type)
  }

  if (roles && user && !roles.includes(user.role)) {
    const initialRoute = getPrivateInitialRoute({ isAdmin: isAdmin() })
    return <Navigate to={initialRoute} state={{ from }} />
  }

  return <>{children}</>
}
